/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Injectable, NgModule } from '@angular/core';
import { HttpClientModule, HttpClient, HttpRequest, XhrFactory } from '@angular/common/http';
import { CoreModule } from './@core/core.module';
import { ThemeModule } from './@theme/theme.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import {
  NbChatModule,
  NbDatepickerModule,
  NbDialogModule,
  NbMenuModule,
  NbSidebarModule,
  NbToastrModule,
  NbWindowModule,
} from '@nebular/theme';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { RecaptchaModule } from 'ng-recaptcha';

import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NB_AUTH_TOKEN_INTERCEPTOR_FILTER } from '@nebular/auth';
import { environment } from 'environments/environment';
import { AuthGuard } from './services/auth/auth-guard.service';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { Ng2TelInputModule } from 'ng2-tel-input';
import {NgxDatatableModule} from '@swimlane/ngx-datatable';
import { NbDateFnsDateModule } from '@nebular/date-fns';

//import { RegisterModule } from './pages/public/auth/register/register.module';


// required for AOT compilation
export function HttpTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@Injectable()
export class NativeBrowserXhr implements XhrFactory {
  constructor() {}
  build(): any {
    return <any>(new (window as any).nativeXMLHttpRequest());
  }
}

@NgModule({
  providers: [
    {
      provide: LocationStrategy, useClass: HashLocationStrategy,
    },
    {
      provide: NB_AUTH_TOKEN_INTERCEPTOR_FILTER,
      useValue: function (req: HttpRequest<any>) {
        if (req.url === environment.AUTH.AUTH_URL) {
          return true;
        }
        return false;
      },
    },
    AuthGuard,
    {
      provide: XhrFactory,
        useClass: NativeBrowserXhr,
      },
  ],
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    NbChatModule.forRoot({
      messageGoogleMapKey: 'AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY',
    }),
    CoreModule.forRoot(),
    ThemeModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
          provide: TranslateLoader,
          useFactory: HttpTranslateLoader,
          deps: [HttpClient]
      },
    }),

    RecaptchaModule,
    Ng2TelInputModule,
    NgbModule,
    NgxDatatableModule,
    NbDateFnsDateModule.forRoot({ format: 'yyyy-MM-dd' }),
    //RegisterModule,
  ],
  bootstrap: [AppComponent],
  exports: [TranslateModule,
  ],
})
export class AppModule {
}

